import { Box, SxProps } from "@mui/material"
import React from "react"

interface MainPageContentContainerProps {
    sx?: SxProps
    children: React.ReactNode
}

export const MainPageContentContainer = ({
    children,
    sx = {},
}: MainPageContentContainerProps) => {
    return (
        <Box
            sx={{
                px: "1.5rem",
                py: "1rem",
                bgcolor: "white",
                borderRadius: "20px",
                filter: "drop-shadow(0px 0px 50px rgba(0, 0, 0, 0.05))",
                ...sx,
            }}
        >
            {children}
        </Box>
    )
}
